export function escapeModalId(modalId) {
  if (typeof CSS !== "undefined" && typeof CSS.escape === "function") {
    return CSS.escape(modalId)
  }

  return modalId.replace(/[^a-zA-Z0-9_-]/g, "\\$&")
}

export function modalRoot(modalId, scopeElement = document) {
  return scopeElement.querySelector(`#${escapeModalId(modalId)}`) || document.getElementById(modalId)
}

export function modalContainer(modalId, scopeElement = document) {
  return modalRoot(modalId, scopeElement)?.querySelector('[data-railsui-modal-target="container"]') ?? null
}

export function openRailsuiModal(application, modalId, scopeElement = document) {
  const root = modalRoot(modalId, scopeElement)
  if (!root) return null

  // show() avoids open()'s toggle-close when a modal is already visible.
  application.getControllerForElementAndIdentifier(root, "railsui-modal")?.show()
  return root
}

export function closeRailsuiModal(application, modalId, scopeElement = document) {
  const root = modalRoot(modalId, scopeElement)
  if (!root) return

  application.getControllerForElementAndIdentifier(root, "railsui-modal")?.close()
}

export function observeModalHidden(modalId, scopeElement, onHidden) {
  const container = modalContainer(modalId, scopeElement)
  if (!container) return null

  let wasOpen = container.getAttribute("aria-hidden") !== "true"

  const observer = new MutationObserver(() => {
    const isOpen = container.getAttribute("aria-hidden") !== "true"

    if (wasOpen && !isOpen) onHidden()

    wasOpen = isOpen
  })

  observer.observe(container, {
    attributes: true,
    attributeFilter: ["aria-hidden", "class"],
  })

  return observer
}
